<template>
	<section>
		<!-- Componentes externos -->
    <crear-actualizar-turno />
    <h3 class="primary--text"><v-icon color="primary">business</v-icon> Turnos</h3>
		<v-card>
			<v-card-text>
				<crud-table
					:headers="headers"
          :url="url"
          :filters="filters"
          :data-graphql="dataGraphql"
					:graphql="graphql"
				>
					<!-- Template injectable de la cabecera de la tabla -->
					<template slot="buttons">
            <v-tooltip bottom>
             <v-btn color="primary" dark
               @click.native.stop="crearActualizarTurno({})"
               slot="activator"
             ><v-icon dark>add</v-icon> {{$t('common.add') }}</v-btn>
             <span>Agregar Turno</span>
           </v-tooltip>
          </template>

					<!-- Template de filas y columnas -->
					<template slot="items" slot-scope="items">
						<!-- Agregar las columnas que consideré necesarias -->
            <td class="text-xs-center">{{ items.item.descripcion }}</td>
            <td class="text-xs-center">{{ items.item.codigo_turno }}</td>
            <td class="text-xs-center">
              <v-tooltip bottom>
                <v-btn
                  icon
                  slot="activator"
                  @click.native="crearActualizarTurno(items.item)">
                  <v-icon>edit</v-icon>
                </v-btn>
                <span>Editar registro</span>
              </v-tooltip>
              <v-tooltip bottom>
                <v-btn
                  icon
                  slot="activator"
                  @click="deleteItem(parseInt(items.item.id), 'turno')">
                  <v-icon color="red">delete</v-icon>
                </v-btn>
                <span>Eliminar registro</span>
              </v-tooltip>
            </td>
          </template>

				</crud-table>
			</v-card-text>
		</v-card>
	</section>
</template>

<script>
import CrudTable from '@/common/util/crud-table/CrudTable.vue'; // Componente Tabla Dinámica
import crud from '@/common/util/crud-table/mixins/crud-table'; // Funciones y Metodos
import CrearActualizarTurno from './dialogs/CrearActualizarTurno' // Componente de creación y actualización

export default {
	// Importación de métodos y funciones de un archivo mixin 
	mixins: [crud],
	// Variables iniciales del componente
	data () {
		return {
			url: 'turnos',
			graphql: true,
			// Cabecera de la tabla
			headers: [
        { text: 'Descripción', value: 'descripcion', align: 'center' },
        { text: 'Código de turno', value: 'descripcion', align: 'center' },
        { text: this.$t('common.actions'), sortable: false, align: 'center' }
      ],
			// Campos solicitados de Graphql(Agregar los que necesite)
			dataGraphql: `
        id
        id_estado
        descripcion
        codigo_turno
        _user_created
        _user_updated
        _created_at
        _updated_at
      `,
			// Filtros del componente CrudTable ejemplo:
			// {
			// 	field: 'Campo definido en Graphql',
			// 	label: 'Etiqueta del input generado',
			// 	type: 'text', // Tipo de input en el filtro
			// 	typeG: 'String' // Tipo definido en Graphql
			// }
			filters: []
		}
	},
	// Funcionalidades que se ejecutan al montar el componente
  mounted () {
    // Verificando si el usuario tiene permiso para interactual con el componente
    const rolesPermitidos = [0] // ID's de roles permitidos
    if (!this.$util.permisoRol(rolesPermitidos)) {
      this.$router.push('/403')
    }

    this.$bus.$on('closeDialog', () => {
      this.updateList()
    })
  },
	// Métodos y funciones del componente
	methods: {
		crearActualizarTurno (item) {
			this.$bus.$emit('openDialogCrearActualizarTurno', item)
		},
		async cambiarEstado (item) {
      let value = item.id_estado === '20' ? 1 : 20
      let data = {
        id_estado: value
      }
      try {
        await this.$service.graphql({
          query: `
            mutation edit($id: ID!, $turno: EditTurno!) {
              turnoEdit(id: $id, turno: $turno) {
                id
              }
            }
          `,
          variables: {
            id: item.id,
            turno: data
          }
        })
        if (value === 1) {
          this.$message.success('Turno habilitado')
        } else {
          this.$message.warning('Turno deshabilitado')
        }
        this.updateList()
      } catch (error) {
        console.log(error)
      }
    }
	},
	// Definición de componentes importados
	components: {
		CrudTable,
		CrearActualizarTurno
	}
}
</script>

<style>

</style>


// WEBPACK FOOTER //
// src/components/admin/turno/Index.vue